import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { FallbackProps } from 'react-error-boundary';
import { MdErrorOutline } from 'react-icons/md';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div
      role="alert"
      className="w-full h-screen flex justify-center items-center"
    >
      <div className="px-6 py-10 bg-[#fdeded] rounded-md">
        <div className="flex justify-start items-start">
          <div className="text-[#d32f2f] text-[22px]">
            <MdErrorOutline />
          </div>
          <div className="ms-3">
            <div className="text-[#5f2120] font-bold text-[20px]">
              <ReturnTranslatedText
                text={`general.${'Error'}`}
                origintext="Error"
              />
            </div>
            <div className="mt-2 text-[18px]">
              <ReturnTranslatedText
                text={`general.${'Something went wrong, please contact us and try again later.'}`}
                origintext="Something went wrong, please contact us and try again later."
              />
            </div>
            <div
              className="mt-4 text-[#5f2120] underline cursor-pointer"
              onClick={() => {
                resetErrorBoundary();
              }}
            >
              <ReturnTranslatedText
                text={`general.${'Home'}`}
                origintext="Home"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
